'use client';

// src/app/[locale]/not-found.tsx
import { Typography } from '@mui/material';
import { useTranslations, useLocale } from 'next-intl';
import styled from 'styled-components';

import Button from '@/ui/components/Button';
import Breadcrumbs from '@/ui/components/Breadcrumbs';
import Footer from '@/ui/containers/layout/footer';
import Header from '@/ui/containers/layout/header';
import LayoutContainer from '@/ui/containers/layout/LayoutContainer';

const Wrapper = styled.div`
  display: flex;
  padding-top: 6.25rem;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
`;

const ButtonWrapper = styled.div`
  margin-top: 2rem;
`;

export default function NotFound(): JSX.Element {
  const t = useTranslations();
  const locale = useLocale();

  // Build locale-specific URL for support homepage
  const supportUrl = locale === 'en' ? '/' : `/${locale}`;

  return (
    <>
      <Header />
      <LayoutContainer>
        <Breadcrumbs items={[{ name: t('breadcrumb-support'), url: supportUrl }, { name: t('not-found-title') }]} />
        <Wrapper>
          <Typography variant="h1" component="h1">
            {t('not-found-title')}
          </Typography>

          <Typography
            variant="body1"
            component="p"
            sx={{
              marginTop: '2rem',
            }}
          >
            {t('not-found-description')}
          </Typography>

          <ButtonWrapper>
            <Button label={t('not-found-buttonLabel')} color="primary" size="xlarge" href="/" />
          </ButtonWrapper>
        </Wrapper>
      </LayoutContainer>
      <Footer />
    </>
  );
}
